import * as actions from '../actions/snackbar';
import { createReducer } from 'redux-act';

const DEFAULT_STATE = {
  notifications: []
};

export default createReducer(
  {
    [actions.enqueueSnackbar]: (state, notification) => {
      const key = notification.options && notification.options.key;

      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            ...notification,
            key: key || new Date().getTime() + Math.random()
          }
        ]
      };
    },
    [actions.closeSnackbar]: (state, key) => {
      const dismissAll = !key;

      return {
        ...state,
        notifications: state.notifications.map(notification =>
          dismissAll || notification.key === key
            ? { ...notification, dismissed: true }
            : { ...notification }
        )
      };
    },
    [actions.removeSnackbar]: (state, key) => {
      return {
        ...state,
        notifications: state.notifications.filter(
          notification => notification.key !== key
        )
      };
    }
  },
  DEFAULT_STATE
);
